import BaseGenericRequest from "../BaseGenericRequest";
import {TaskDeleteMultipleRequest} from "../TaskDeleteMultipleRequest";
import {TaskDeleteResponse} from "../TaskDeleteResponse";
import {METHOD} from "@cuatroochenta/co-generic-request";
import {generateRoute} from "../../utils/Router";
import Urls from "../Urls";

export default class TaskParkingAreaTypeDelete extends BaseGenericRequest<TaskDeleteMultipleRequest, TaskDeleteResponse> {

    private readonly data: TaskDeleteMultipleRequest;

    public constructor(itemIdOrIds: string | string[]) {
        if (typeof itemIdOrIds === 'string') {
            super(METHOD.DELETE, generateRoute(Urls.URL_PARKING_AREA_TYPE_DELETE, {uuid: itemIdOrIds}));
        } else {
            super(METHOD.DELETE, generateRoute(Urls.URL_PARKING_AREA_TYPE_DELETE_MULTIPLE));
            this.data = {ids: itemIdOrIds};
        }
    }

    protected getRequest(): TaskDeleteMultipleRequest {
        return this.data;
    }

}
